import { ShopTagInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'


export type SingleShopTagQuery = {
  singleShopTag: ShopTagInfo
}

export type SingleShopTagVariables = {
  shopTagId?: GQL_ID
}

export const GQL_QUERY_SINGLE_SHOP_TAG = gql`
  query singleShopTag($shopTagId: ID!) {
    singleShopTag(id: $shopTagId) {
      id
      name
      system_name
      icon_id
      icon {
        url
      }
      sort_order
      i18n {
        language_code
        name
      }
    }
  }
`

export const useFetchSingleShopTag = (variables: SingleShopTagVariables) => {
  const { data, loading, error, refetch } = useQuery<SingleShopTagQuery, SingleShopTagVariables>(
    GQL_QUERY_SINGLE_SHOP_TAG,
    {
      variables,
      fetchPolicy: 'cache-and-network',
      skip: !variables.shopTagId
    }
  )

  const shopTag = data?.singleShopTag

  return {
    shopTag,
    data,
    loading,
    error,
    refetch,
  }
}